import '../../index.scss';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Tooltip } from '@material-ui/core';
import { MultipleAddButton } from './MultipleAddButton';
import { MultipleRemoveButton } from './MultipleRemoveButton';
import { createMarkup, translate } from '@utils';
import { DragDrop } from '@images/icons';

export const MultipleFormGroup = (props) => {
  const { handleOnDndEnd, components, renderElement, handleAdd, handleDelete, multipleItems } =
    props;

  return (
    <>
      <DragDropContext onDragEnd={handleOnDndEnd}>
        <Droppable droppableId="droppable">
          {(provided) => (
            <>
              <MultipleAddButton handleAdd={handleAdd} />
              <div
                className="questions-container"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {multipleItems.map((item, index) => (
                  <Draggable
                    key={`dndItem-${index}`}
                    draggableId={`dndItem-${index}`}
                    index={index}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className="questions-block">
                          <div className="drag-handle">
                            <Tooltip title={translate('drag')} arrow>
                              <DragDrop />
                            </Tooltip>
                          </div>
                          <div className="questions-item">
                            {components.map((component) => {
                              const { key, style, label } = component;

                              return (
                                <div key={key} style={style}>
                                  <div dangerouslySetInnerHTML={createMarkup(label)}></div>
                                  {renderElement(component, index)}
                                </div>
                              );
                            })}
                          </div>
                          <MultipleRemoveButton id={index} handleDelete={handleDelete} />
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            </>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
};
